<template>
<div id="app" class="content-wrapper">

        <!-- <el-button type="primary"  size="mini" class="back" @click="goBack()">返回</el-button> -->
        <div class="ibox-title">
            <h5>详情</h5>
        </div>
        <div class="main_mess">
            <p class="nav_cha">联系人信息</p>
            <ul>
                <li class="mess_li">
                    <span class="fileing">姓名：</span>
                    <div class="filediv">{{userName}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">性别：</span>
                    <div class="filediv">{{sexName}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">生日：</span>
                    <div class="filediv">{{birthday}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">手机号码：</span>
                    <div class="filediv">{{loginTel}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">邮箱：</span>
                    <div class="filediv">{{loginEmail}}</div>
                </li>
            </ul>
            <p class="nav_cha">学校信息</p>
            <ul>
                <li class="mess_li">
                    <span class="fileing">学校名称：</span>
                    <div class="filediv">{{fullName}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">学校简称：</span>
                    <div class="filediv">{{shortName}}</div>
                </li>
                 <li class="mess_li">
                    <span class="fileing">学校网址：</span>
                    <div class="filediv">{{website}}</div>
                </li>
                <li class="mess_li">
                    <span class="fileing">学校地址：</span>
                    <div class="filediv">{{street}}</div>
                </li>
                <li class="mess_li" style="height: 230px;">
                    <span class="fileing">证件图片：</span>
                    <img class="fileimg" :src="bizLicenseImg">
                </li>
            </ul>
            <p class="nav_cha">主管机构</p>
            <ul>
                <li class="mess_li">
                    <span class="fileing">主管妇幼保健院：</span>
                    <div class="filediv">{{health.fullName}}</div>
                </li>
            </ul>
        </div>
</div>

</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件

export default {
  name: 'app',
  data () {
    return {
      userName: '',
      sexName: '',
      birthday: '',
      loginTel: '',
      loginEmail: '',
      fullName: '',
      shortName: '',
      website: '',
      street: '',
      bizLicenseImg: config.imgUrl + 'logo_hhs.png',
      healthCareID: '',
      health: {
        fullName: ''
      }
            //, dialogTableVisible:false
    }
  },
  methods: {
    loadInt () {
      //   初始化渲染
      var self = this
      self.orgID = self.$route.params.id
      api.post(config.host + 'orgkind/getOrgKindDetail.do', {'orgID': self.orgID}).then((data) => {
        var item = data.body
        self.healthCareID = item.healthCareID
        self.userName = item.userName
        self.sexName = item.sexName
        self.birthday = item.birthday
        self.loginTel = item.loginTel
        self.loginEmail = item.loginEmail
        self.fullName = item.fullName
        self.shortName = item.shortName
        self.website = item.website
        self.street = item.street
        if (item.bizLicenseImg !== '' && item.bizLicenseImg !== undefined) {
          self.bizLicenseImg = item.bizLicenseImg
          // if (item.bizLicenseImg.indexOf('://') < 0) {
          //   api.post(config.khsHost + 'base/common/getImgShowBaseUrl.do').then((response) => {
          //     if (response.success === true) {
          //       self.bizLicenseImg = response.body + item.bizLicenseImg
          //     }
          //   })
          // } else {
          //   self.bizLicenseImg = item.bizLicenseImg
          // }
        } else {
          self.bizLicenseImg = config.imgUrl + 'logo_hhs.png'
        }
        api.post(config.host + 'org/KHS_getOrgDetail.do', {'orgID': self.healthCareID}).then((data) => {
          var item = data.body
          self.health.fullName = item.fullName
        })
      })
    }
  },
  created () {
    this.loadInt()
  },
  watch: {
    $route: {
      handler: function () {
        this.loadInt()
      },
      deep: true
    }
  }
}
</script>

<style>
.main_mess ul{
    overflow:hidden;
    margin-bottom:20px;
}
.nav_cha {
    padding-left: 10px;
    border-left: 5px solid #1ab394;
    height: 16px;
    line-height: 16px;
    margin: 12px;
    font-weight: bold;
    text-align: left;
}
.mess_li {
    float: left;
    width: 100%;
    height:30px;
    line-height:30px;
    margin-left: 30px;
    margin-top: 15px;
    list-style: none;
    text-align: left;
}
.filediv{
    display:inline-block;
}
.fileimg{
   display:block;
   width:200px;
   height:200px;
   margin-left: 76px;
}
.back{
    margin-left: 28px;
    margin-bottom: 20px;
}
.main_mess{
    border-top: 1px solid #ddd;
    padding-top: 14px;
}
</style>
<style scoped>
    .el-dialog {
        min-width: 70%;
    }
</style>


// WEBPACK FOOTER //
// src/components/orgmgr/orgmgrDetail.vue